import { PageLayout } from "@components/ui/PageLayout"
import { contactPageQueryOptions } from "@data/public-page-data-query"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/route-head"
import { ContactPage } from "./-ContactPage"

export const Route = createFileRoute("/$locale/contact/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(contactPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "contact", path: `/${locale}/contact` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <PageLayout>
      <ContactPage data={data} />
    </PageLayout>
  )
}
